import PageProtectedLayout from "../../../../components/Page/PageProtectedLayout.jsx";
import SelectDateVitamins from "./SelectDateVitamins.jsx";
import { useTranslation } from '../../../../language';

export default function BloodVitaminsWelcome() {

  const { t } = useTranslation();

return (

    <PageProtectedLayout

      headline={t('page_hl_vitamin')}
      specify={t('page_sp_vitamins_nutrients')}

      >

      {/* Main Page Content */}

       <SelectDateVitamins />


    </PageProtectedLayout>

  );
}
